module.exports = __webpack_public_path__ + "static/media/default_user.47a33831.png";